
import React from 'react';
import { useSleepSchedule } from './SleepScheduleContext';
import { Smile } from 'lucide-react';

interface SleepScheduleHeaderProps {
  childName: string;
}

const SleepScheduleHeader: React.FC<SleepScheduleHeaderProps> = ({ childName }) => {
  const { 
    wakeWindowsOnTime,
    bedtimeConsistency
  } = useSleepSchedule();
  
  // Calculate overall adherence to schedule
  const totalItems = wakeWindowsOnTime.total + bedtimeConsistency.total;
  const itemsOnTime = wakeWindowsOnTime.completed + bedtimeConsistency.onTime;
  const adherencePercentage = totalItems > 0 ? (itemsOnTime / totalItems) * 100 : 0;
  
  // Determine emoji based on adherence
  const getEmoji = () => {
    if (adherencePercentage >= 80) {
      return <div className="w-16 h-16 bg-yellow-300 rounded-full flex items-center justify-center">
        <Smile className="w-12 h-12 text-yellow-600" />
      </div>;
    } else if (adherencePercentage >= 50) {
      return <Smile className="w-16 h-16 text-yellow-400" />;
    } else {
      return <Smile className="w-16 h-16 text-yellow-200" />;
    }
  };

  return (
    <div className="flex items-center justify-between">
      <h1 className="text-4xl font-bold text-purple-800">
        Following the Schedule
      </h1>
      <div className="flex items-center">
        {getEmoji()}
      </div>
    </div>
  );
};

export default SleepScheduleHeader;
